// paper & background
$paper: #fdfdfd;
$background: #e3f2fd;

// primary
$primaryLight: #48ADA2;
$primaryMain: #1B998B;
$primaryDark: #126B61;
$primary200: #48ADA2;
$primary800: #126B61;

// secondary
$secondaryLight: #5F528E;
$secondaryMain: #372772;
$secondaryDark: #261B4F;
$secondary200: #5F528E;
$secondary800: #261B4F;

// success Colors
$successLight: #81c784;
$success200: #81c784;
$successMain: #4CAF50;
$successDark: #388e3c;

// error
$errorLight: #e57373;
$errorMain: #F44336;
$errorDark: #d32f2f;

// orange
$orangeLight: #F89A76;
$orangeMain: #F78154;
$orangeDark: #AC5A3A;

// yellow
$yellowLight: #FFF4C2;
$yellowMain: #FFE985;
$yellowDark: #FFD61F;

// warning
$warningLight: #F89A76;
$warningMain: #F78154;
$warningDark: #AC5A3A;

// grey
$grey50: #fafafa;
$grey100: #f5f5f5;
$grey200: #eeeeee;
$grey300: #e0e0e0;
$grey500: #9e9e9e;
$grey600: #757575;
$grey700: #616161;
$grey900: #212121;

// ==============================|| DARK THEME VARIANTS ||============================== //

// paper & background
$darkBackground: #1a223f; // level 3
$darkPaper: #111936; // level 4

// dark 800 & 900
$darkLevel1: #29314f; // level 1
$darkLevel2: #212946; // level 2

// primary dark
$darkPrimaryLight: #eeedfd;
$darkPrimaryMain: #7267ef;
$darkPrimaryDark: #6a5fed;
$darkPrimary200: #b9b3f7;
$darkPrimary800: #554ae8;

// secondary dark
$darkSecondaryLight: #eeedfd;
$darkSecondaryMain: #7267ef;
$darkSecondaryDark: #6a5fed;
$darkSecondary200: #b9b3f7;
$darkSecondary800: #554ae8;

// text variants
$darkTextTitle: #d7dcec;
$darkTextPrimary: #bdc8f0;
$darkTextSecondary: #8492c4;

// ==============================|| JAVASCRIPT ||============================== //

:export {
    // paper & background
    paper: $paper;
    background: $background;

    // primary
    primaryLight: $primaryLight;
    primary200: $primary200;
    primaryMain: $primaryMain;
    primaryDark: $primaryDark;
    primary800: $primary800;

    // secondary
    secondaryLight: $secondaryLight;
    secondary200: $secondary200;
    secondaryMain: $secondaryMain;
    secondaryDark: $secondaryDark;
    secondary800: $secondary800;

    // success
    successLight: $successLight;
    success200: $success200;
    successMain: $successMain;
    successDark: $successDark;

    // error
    errorLight: $errorLight;
    errorMain: $errorMain;
    errorDark: $errorDark;

    // orange
    orangeLight: $orangeLight;
    orangeMain: $orangeMain;
    orangeDark: $orangeDark;

    // yellow
    yellowLight: $yellowLight;
    yellowMain: $yellowMain;
    yellowDark: $yellowDark;

    // warning
    warningLight: $warningLight;
    warningMain: $warningMain;
    warningDark: $warningDark;

    // grey
    grey50: $grey50;
    grey100: $grey100;
    grey200: $grey200;
    grey300: $grey300;
    grey500: $grey500;
    grey600: $grey600;
    grey700: $grey700;
    grey900: $grey900;

    // ==============================|| DARK THEME VARIANTS ||============================== //

    // paper & background
    darkPaper: $darkPaper;
    darkBackground: $darkBackground;

    // dark 800 & 900
    darkLevel1: $darkLevel1;
    darkLevel2: $darkLevel2;

    // text variants
    darkTextTitle: $darkTextTitle;
    darkTextPrimary: $darkTextPrimary;
    darkTextSecondary: $darkTextSecondary;

    // primary dark
    darkPrimaryLight: $darkPrimaryLight;
    darkPrimaryMain: $darkPrimaryMain;
    darkPrimaryDark: $darkPrimaryDark;
    darkPrimary200: $darkPrimary200;
    darkPrimary800: $darkPrimary800;

    // secondary dark
    darkSecondaryLight: $darkSecondaryLight;
    darkSecondaryMain: $darkSecondaryMain;
    darkSecondaryDark: $darkSecondaryDark;
    darkSecondary200: $darkSecondary200;
    darkSecondary800: $darkSecondary800;
}
